import React from 'react'
import { Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap'
import {
  DefaultTable,
  PaginationTable,
  SearchTable,
  SortingTable,
  LoadingStateTable,
  HiddenColumns
} from './ReactTable'

const ReactTable = () => {
  document.title = 'React Tables | SocialBooth - Admin Dashboard'
  return (
    <React.Fragment>
      <div className='page-content'>
        <Container fluid>
          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader>
                  <h5 className='card-title mb-0'>Default Tables</h5>
                </CardHeader>
                <CardBody>
                  <DefaultTable />
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader>
                  <h5 className='card-title mb-0'>Pagination</h5>
                </CardHeader>
                <CardBody>
                  <PaginationTable />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader>
                  <h5 className='card-title mb-0'>Search</h5>
                </CardHeader>
                <CardBody>
                  <SearchTable />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader>
                  <h5 className='card-title mb-0'>Sorting</h5>
                </CardHeader>
                <CardBody>
                  <SortingTable />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader>
                  <h5 className='card-title mb-0'>Loading State</h5>
                </CardHeader>
                <CardBody>
                  <LoadingStateTable />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader>
                  <h5 className='card-title mb-0'>Hidden Columns</h5>
                </CardHeader>
                <CardBody>
                  <HiddenColumns />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default ReactTable
